import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IonButton, IonChip, IonIcon, IonItemDivider, IonLabel } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { IInfiniteScrollHeaderConfig } from '../../models';

@Component({
  selector: 'lib-infinite-scroll-header',
  templateUrl: './infinite-scroll-header.component.html',
  styleUrls: ['./infinite-scroll-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonItemDivider, IonIcon, IonButton, IonChip, IonLabel, TranslateModule, DatePipe],
})
export class InfiniteScrollHeaderComponent {
  public readonly infiniteScrollConfig = input.required<IInfiniteScrollHeaderConfig>();
}
